import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.js'
import Popper from "@popperjs/core/dist/umd/popper";
import desktopNav from "./components/desktopNav";
import hcOffcanvasNav from "hc-offcanvas-nav";
import {
  lazyloadVideoElement,
  lazyloadiFrameElement,
  backgroundImageLazyLoad,
} from "./utilities/lazyload";
import { navigation, bodyOverlay, navigationFunctions } from "./components/nav";
import { contactBar } from "./components/contactBar";
import { initSwiper } from "./components/sliders";
import googleMaps from "./components/map";
import animations from "./components/animations";
import AOS from "aos";
import tiles from "./components/tiles";
import {
  statSwiper,
  animateStats,
  runAnimatedStats,
} from "./components/animated-stats";
import * as lightbox from "fslightbox";
import http from "./services/httpService";
import { isEmpty } from "./utilities/globalUtil";
import { injectHtml } from "./utilities/htmlUtil";
import testimonials from "./components/testimonials";
import teamsSlider from "./components/teamsSlider";
import { initStaffFilters } from "./staffFilters";
import findaleaguemap from "./components/findaleaguemap";
import { statYearSelect } from "./components/statTiles";
import initMasonry from "./components/masonry";
import { initTagFilters } from "./tagFilters";
import initModalMap from './components/modal-maps';

$(function () {
  AOS.init();

  // Utilities
  backgroundImageLazyLoad();
  lazyloadiFrameElement();
  lazyloadVideoElement();
  isEmpty();
  injectHtml();

  // Services

  //animations
  animations();

  // Navigation
  desktopNav();
  navigationFunctions(navigation);
  bodyOverlay();

  // Componenets
  contactBar();

  //Sliders
  initSwiper();

  // Google Maps
  googleMaps();
  initModalMap();

  // block scripts
  tiles();

  document.addEventListener("scroll", runAnimatedStats);

  statSwiper();

  testimonials();

  teamsSlider();

  if (
    window.location.href.indexOf("news") ||
    window.location.href.indexOf("gb-news")
  ) {
    initTagFilters();
  }

  if (window.location.href.indexOf("staff") || window.location.href.indexOf("contact")) {
    initStaffFilters();
  }


  statYearSelect();


  initMasonry();
});
